import { render } from "./component-archive-date.vue?vue&type=template&id=d01feef4"
import script from "./component-archive-date.vue?vue&type=script&setup=true&lang=js"
export * from "./component-archive-date.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-archive-date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d01feef4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d01feef4', __exports__)) {
    api.reload('d01feef4', __exports__)
  }
  
  module.hot.accept("./component-archive-date.vue?vue&type=template&id=d01feef4", () => {
    api.rerender('d01feef4', render)
  })

}


export default __exports__